module.exports = __webpack_public_path__ + "static/media/Portrait-10048.580f03e7.jpg";